<!-- 定投收益 - 单行数据 -->
<template>
  <div class="fixed-invest-row">
    <div class="fixed-invest-item left-date">{{item.date}}</div>
    <div :class="isShowSmartInvest ? ['fixed-invest-item', 'mid-rate']
      :['fixed-invest-item','last-right']"
      :style="{ color: getRateColor(item.ptdt)}"
      >{{item.ptdt}}</div>
    <div v-if="isShowSmartInvest" class="fixed-invest-item last-right"
      :style="{ color: getRateColor(item.bestDt)}"
      >{{item.bestDt}}</div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  name: 'fixed-invest-row',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isShowSmartInvest: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getRateColor: tool.getRateColor,
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
}
.fixed-invest-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  font-size: 30px;
  color: #000000;
  line-height: 30px;
  padding: 20px 0 8px;
  .fixed-invest-item {
    display: flex;
    font-family: DINAlternate-Bold;
  }
  .left-date {
    flex: 1;
    justify-content: flex-start;
  }
  .mid-rate {
    flex: 1;
    justify-content: center;
    font-family: DINAlternate-Bold;
  }
  .last-right {
    flex: 1;
    justify-content: flex-end;
    font-family: DINAlternate-Bold;
  }
}
</style>
